export async function useFetchPreviewPage() {
  const route = useRoute()
  const pageId = route.query.id !== undefined ? route.query.id : route.params.id

  const { data: page } = await useFetch<Page>(`/api/pages/${pageId}`, {
    baseURL: useRuntimeConfig().public.cms,
    method: 'get',
    query: {
      populate: 'deep',
    },
    server: false,
    deep: false,
    transform: (response: any) => {
      const data = response.data
      return {
        content: data.content.filter(
          (component: Content) => !component.hide_module
        ),
        description: data.description,
        locale: data.locale,
        localizations: data.localizations,
        metatags: data.metatags,
        title: data.title,
      } as Page
    },
  })
  return page
}
